<p-table [value]="projects"
         [rows]="100"
         [paginator]="true"
         [style]="{'margin-top':'10px'}"
         #table
         dataKey="roleGroup"
>
  <ng-template pTemplate="header">
    <tr style="white-space: nowrap;font-weight: bold">
      <th style="width: 10%; font-weight: bold;">Projects</th>
      <th style="width: 20px; font-weight: bold;"></th>
      <th style="font-weight: bold;">Broadcast Source(s)</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
    <tr>
      <td>
        {{item.projectName}}
      </td>
      <td><i class="fa fa-copy" [routerLink]="['/projects', 'clone', item.projectId]"></i></td>
      <td><span *ngFor="let source of item.sources">{{source.projectName}}<i class="fa fa-edit" [routerLink]="['/projects', 'clone', source.projectId, item.projectId]"></i></span><i class="fa fa-plus" [routerLink]="['/projects', 'clone', '-1', item.projectId]"></i></td>
    </tr>
  </ng-template>

</p-table>
